import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserCheck01Filled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22.7072 15.2929C23.0977 15.6834 23.0977 16.3166 22.7072 16.7071L18.7072 20.7071C18.3166 21.0976 17.6835 21.0976 17.2929 20.7071L15.2929 18.7071C14.9024 18.3166 14.9024 17.6834 15.2929 17.2929C15.6835 16.9024 16.3166 16.9024 16.7072 17.2929L18 18.5858L21.2929 15.2929C21.6835 14.9024 22.3166 14.9024 22.7072 15.2929Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.78606 14.5C8.2651 14.5003 9.74415 14.5006 11.2232 14.5C11.3423 14.4999 11.4846 14.4999 11.6099 14.5101C11.7551 14.522 11.9631 14.5524 12.181 14.6635C12.4633 14.8073 12.6927 15.0368 12.8366 15.319C12.9476 15.537 12.9781 15.745 12.9899 15.8902C13.0002 16.0155 13.0001 16.1578 13.0001 16.2769C12.9996 17.5923 12.9996 18.9077 13.0001 20.2231C13.0001 20.3423 13.0002 20.4845 12.9899 20.6098C12.9781 20.7551 12.9476 20.963 12.8366 21.181C12.6927 21.4632 12.4633 21.6927 12.181 21.8365C11.9631 21.9476 11.7551 21.978 11.6099 21.9899C11.4846 22.0001 11.3423 22.0001 11.2232 22C8.3458 21.999 5.46791 21.9847 2.59057 22.0001C2.5192 22.0005 2.37575 22.0012 2.23958 21.9772C1.61856 21.8677 1.13234 21.3815 1.02284 20.7605C0.998829 20.6243 0.999593 20.4809 0.999973 20.4095C1.00312 19.8186 0.972938 19.2163 1.07601 18.6318C1.44102 16.5617 3.06175 14.941 5.13181 14.576C5.56422 14.4997 6.05938 14.4998 6.78606 14.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.50005 7.5C4.50005 4.46243 6.96248 2 10.0001 2C13.0376 2 15.5001 4.46243 15.5001 7.5C15.5001 10.5376 13.0376 13 10.0001 13C6.96248 13 4.50005 10.5376 4.50005 7.5Z",
			fill: "currentColor"
		})
	]
});
export default SvgUserCheck01Filled;
